<template>
  <div :class="['vform-header position-relative', config.isInline && isTopBottomBar ? 'inline-element no-margin-bottom' : 'w-100', config.emphasized ? 'vform-emphasized' : '']">
    <slot name="dropzone"></slot>
    <div class="w-100"/>
    <editor-overlay
        v-if="editable"
        :active="editorSelected"
        :can-have-template="false"
        @removeBlock="$emit('removeBlock')"
        @editProperty="editProperty"
        @editTemplate="editTemplate"
    />
    <div class="text"
         contenteditable="false"
         @input="onInput"
         @keydown.enter="leaveEditing(uniqueId)"
         :id="uniqueId"
         @click.stop="doNothing"
         :style="{color: config.fontColor ? config.fontColor : fontColor ? fontColor : ''}"
    >
      {{ state.progress }} / {{ state.totalSlides }}
      <div class="bar-container">
        <div class="bar" :style="barStyle()" />
      </div>
      </div>
  </div>
</template>

<script>
import ElementMixin from "@/components/vForm/mixins/ElementMixin.js.vue";
import EditorOverlay from "./EditorOverlay";
export default {
  name: "Headline",
  components: {
    EditorOverlay
  },
  mixins: [ElementMixin],
  props: {
    state: {type: Object, required: true}
  },
  data() {
    return {
      localString: ""
    };
  },
  beforeMount() {
    this.setUniqueId();
    this.setLocalString();
  },
  mounted() {
    this.increaseCounter();
    this.addListener(document, "click", this.documentClick, 'headline-click');
  },
  methods: {
    setLocalString() {
      this.localString = this.getLabel(this.config, this.$store.getters.getSelectedFormLanguage);
    },
    documentClick() {
      this.leaveEditing(this.uniqueId);
    },
    onInput(e) {
      this.setLabel(this.config, this.$store.getters.getSelectedFormLanguage, e.target.innerText);
    },
    save() {
      this.editing = false;
    },
    setEditing() {
      if(this.editable) {
        this.editing = true;
        this.setCursor(this.uniqueId);
      }
    },
    validate() {
        return true;
    },
    checkRequired() {
        return true;
    },
    toLighterColor(color) {
      if (!color) { return null; }
      // hex with existing alpha (#rrggbbaa)
      if (/^#[0-9a-fA-F]{8}$/.test(color)) {
        const r = parseInt(color.slice(1, 3), 16);
        const g = parseInt(color.slice(3, 5), 16);
        const b = parseInt(color.slice(5, 7), 16);
        const a = (parseInt(color.slice(7, 9), 16) / 255 * 0.5).toFixed(3);
        return `rgba(${r},${g},${b},${a})`;
      }
      // plain hex (#rrggbb or #rgb)
      if (/^#[0-9a-fA-F]{3,6}$/.test(color)) {
        return color + '80';
      }
      // rgba(...)
      if (color.startsWith('rgba(')) {
        return color.replace(/[\d.]+\)$/, (m) => (parseFloat(m) * 0.5).toFixed(3) + ')');
      }
      // rgb(...)
      if (color.startsWith('rgb(')) {
        return color.replace('rgb(', 'rgba(').replace(')', ',0.5)');
      }
      return color;
    },
    barStyle() {
      const width = (this.state.totalSlides > 0 ? (this.state.progress / this.state.totalSlides * 100) : 0) + '%';
      const baseColor = this.config.barColor || '#433a81';
      const lightColor = this.toLighterColor(this.config.barColor) || '#8276ce';
      return {
        width,
        borderRight: `1px solid ${baseColor}`,
        background: `repeating-linear-gradient(45deg, ${baseColor} 0, ${baseColor} 2px, ${lightColor} 2px, ${lightColor} 4px)`
      };
    },
    getData() {
      return {data: this.getLabel(this.config, this.$store.getters.getSelectedFormLanguage), type: 'headline'};
    }
  }
}
</script>

<style lang="scss" scoped>
  .vform-header {
    &.inline-element {
      min-width: 150px;
    }
  }
  .bar-container {
    height: 20px;
    width: 100%;
    border: 1px solid #383838;
    background-color: #c3ccd2;
    border-radius: 3px;
  }
  .bar {
    height: 100%;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
</style>